import ProtectedComponent from '../../services/protectedComponent';
import { MdHandyman } from "react-icons/md";

export default function DropDownNavPlus({account}) {
    const base_root = window.location.host

    return (
            <ProtectedComponent account={account} requiredPermissions={["superAdmin","inventoryCreate","inventoryAdjustCreate","salesOrderCreate","invoiceCreate","customerCreate","paymentReceiveCreate","shipmentCreate","purchaseOrderCreate","billCreate","purchaseReceiveCreate","vendorCreate","paymentMadeCreate","serviceHubCreate","productUnitCreate"]}>
            <li className="nav-item dropdown">
                <a className="nav-link" data-toggle="dropdown" href="#" aria-expanded="true">
                    <i className="fas fa-plus-circle" />
                    {/* <span className='d-none d-md-inline-block ml-2'>New</span> */}
                </a>
                <div className="dropdown-menu dropdown-menu-md dropdown-menu-right" style={{left: 'inherit', right: 0, maxHeight: '400px', overflow: 'auto'}}>
                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","inventoryCreate"]}>
                    <a className="dropdown-item mb-1" href="/item/form">
                        <i className="fas fa-tag mr-1" style={{width: '20px'}} /> Item
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","inventoryAdjustCreate"]}>
                    <a className="dropdown-item mb-1" href="/inventory-adjustment/form">
                        <i className="fas fa-percentage mr-1" style={{width: '20px'}} /> Inventory Adjustment
                    </a>
                    </ProtectedComponent>

                    {/* <ProtectedComponent account={account} requiredPermissions={["superAdmin","inventoryCreate","inventoryAdjustCreate"]}>
                    <div className="dropdown-divider" />
                    </ProtectedComponent> */}
                    
                    {/* Sales */}
                    
                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","salesOrderCreate"]}>
                    <a className="dropdown-item mb-1" href="/sales/form">
                        <i className="fas fa-shopping-cart mr-1" style={{width: '20px'}} /> Sales Order
                    </a>
                    </ProtectedComponent>
                    
                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","invoiceCreate"]}>
                    <a className="dropdown-item mb-1" href="/invoices/form">
                        <i className="fas fa-file mr-1" style={{width: '20px'}} /> Invoice
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","customerCreate"]}>
                    <a className="dropdown-item mb-1" href="/customers/form">
                        <i className="fas fa-user-tag mr-1" style={{width: '20px'}} /> Customers
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","paymentReceiveCreate"]}>
                    <a className="dropdown-item mb-1" href="/payment-receives/new">
                        <i className="fas fa-receipt mr-1" style={{width: '20px'}} /> Receive Payment
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","shipmentCreate"]}>
                    <a className="dropdown-item mb-1" href="/shipments/form">
                        <i className="fas fa-shipping-fast mr-2" /> Ship Order
                    </a>
                    </ProtectedComponent>

                    {/* <ProtectedComponent account={account} requiredPermissions={["superAdmin","salesOrderCreate","invoiceCreate","customerCreate","paymentReceiveCreate","shipmentCreate"]}>
                    <div className="dropdown-divider" />
                    </ProtectedComponent> */}
                    
                    {/* Purchase Order */}

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","purchaseOrderCreate"]}>
                    <a className="dropdown-item mb-1" href="/purchases/new">
                        <i className="fas fa-shopping-bag mr-1" style={{width: '20px'}} /> Purchase Order
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","billCreate"]}>
                    <a className="dropdown-item mb-1" href="/bills/new">
                        <i className="fas fa-file-alt mr-1" style={{width: '20px'}} /> Bill
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","paymentMadeCreate"]}>
                    <a className="dropdown-item mb-1" href="/payment-made/new">
                        <i className="fas fa-money-check mr-1" style={{width: '20px'}} /> Pay Bill
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","vendorCreate"]}>
                    <a className="dropdown-item mb-1" href="/vendors/form">
                        <i className="fas fa-store mr-1" style={{width: '20px'}} /> Vendor
                    </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","purchaseReceiveCreate"]}>
                    <a className="dropdown-item mb-1" href="/purchase-receives/new">
                        <i className="fas fa-dolly-flatbed mr-1" style={{width: '20px'}} /> Receive Purchase
                    </a>
                    </ProtectedComponent>
                    
                    {/* <ProtectedComponent account={account} requiredPermissions={["superAdmin",,"purchaseOrderCreate","billCreate","purchaseReceiveCreate","vendorCreate","paymentMadeCreate"]}>
                    <div className="dropdown-divider" />
                    </ProtectedComponent> */}

                    {/* PolarCare */}

                    {
                    base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com" ? 
                    <>
                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","serviceHubCreate"]}>
                        <a className="dropdown-item mb-1" href="/service-requests/new">
                            <MdHandyman size={20} className='mr-2' />Service Request
                        </a>
                    </ProtectedComponent>

                    <ProtectedComponent account={account} requiredPermissions={["superAdmin","productUnitCreate"]}>
                    <a className="dropdown-item mb-1" href="/product-units/new">
                        <i className="fas fa-tag mr-1" style={{width: '20px'}} /> Product Unit
                    </a>
                    </ProtectedComponent> 
                    </> : ""
                    }
                </div>
            </li>
            </ProtectedComponent>)
}